var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.socials.length)?_c('div',{staticClass:"d-flex"},_vm._l((_vm.socials),function(ref,index){
var needHost = ref.needHost; if ( needHost === void 0 ) needHost = false;
var network = ref.network;
var url = ref.url; if ( url === void 0 ) url = '';
var target = ref.target; if ( target === void 0 ) target = '_blank';
var html = ref.html;
var className = ref.className; if ( className === void 0 ) className = '';
return _c('a',{key:index,class:className,attrs:{"href":_vm.generateUrl(needHost, network, url),"target":target}},[(html && html.length)?_c('span',{domProps:{"innerHTML":_vm._s(html)}}):_vm._e()])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }